import Icon from '../components/Icon.vue'

Icon.register({
  donate: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 416c-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208-93.1 208-208 208zM233.8 97.4c-32.7 0.9-59 28.4-59.1 62.4 0 27.7 18 52.4 43.7 60.1l62.3 18.7c7.1 2.1 12.1 9.4 12.1 17.6 0 10.1-7.3 18.3-16.3 18.3h-38.9c-6.4 0-12.4-1.7-17.8-5.1-4.5-2.8-10.2-2.7-14 1l-16.3 15.5c-5 4.8-4.4 13 1.2 17.1 12.5 9.3 27.5 14.6 43 15.4v17c0 9.2 7.4 16.6 16.6 16.6h11.1c9.2 0 16.6-7.4 16.6-16.6v-16.8c32.7-0.9 59.1-28.4 59.1-62.4 0-27.7-18-52.4-43.7-60.1l-62.3-18.7c-7.1-2.1-12.1-9.4-12.1-17.6 0-10.1 7.3-18.3 16.3-18.3h38.9c6.4 0 12.4 1.7 17.8 5.1 4.5 2.8 10.2 2.7 14-1l16.3-15.5c5-4.8 4.4-13-1.2-17.1-12.5-9.3-27.5-14.6-43-15.4v-17c0-9.2-7.4-16.6-16.6-16.6h-11.1c-9.2 0-16.6 7.4-16.6 16.6v16.8zM480 352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32h32.4c19.7 26 44.6 47.7 73 64h-63.8c-5.3 0-9.6 3.6-9.6 8v16c0 4.4 4.3 8 9.6 8h364.7c5.3 0 9.6-3.6 9.6-8v-16c0-4.4-4.3-8-9.6-8h-63.8c28.4-16.3 53.4-38 73-64h32.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/donate.js
// module id = 1223
// module chunks = 0